import React, { useEffect, useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { teams } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import AddTeamDetailsForm from '../../containers/AddTeamDetailsForm';
import { useDispatch, useSelector } from 'react-redux';
import TeamDetailPage from '../../containers/TeamDetailPage';
import { resetSelectedTeam, setFacilitiesDetails, setSelectedTeam, setStaffDetails } from '../../redux/reducers/dataCaptures';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteTeam, getFacilitiesDetails, getStaffDetails } from '../../api/dataCapture';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const TeamsTable = (props?: any) => {
    const { addData, manageDeleteRow } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const data = useSelector((state:any) => state.dataCaptures.teamDetails);
  const dispatch = useDispatch();
  const currentClub = useSelector((state:any) => state.clubDetails);
  const staffDetails = useSelector((state:any) => state.dataCaptures.staffDetails);
  const facilitiesDetails = useSelector((state:any) => state.dataCaptures.facilitiesDetails);
  const [isFetchingStaffs, setIsFetchingStaffs] = useState(false);
  const [isFetchingFacilities, setIsFetchingFacilities] = useState(false);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
      key: '', displayName: 'name',
    },
    {
        key: '', displayName: 'established',
    },
    {
        key: '', displayName: 'age group',
    },
    {
        key: '', displayName: 'staff supervisor',
    },
    {
        key: '', displayName: 'practice grounds',
    },
    {
        key: '', displayName: '',
    },
  ]
 
      const fetchStaffList = async () => {
          setIsFetchingStaffs(true);
          const response = await getStaffDetails({ clubId: currentClub?.id, isPast: false });
          dispatch(setStaffDetails(response));
          setIsFetchingStaffs(false);
      }

      const fetchFacilityList = async () => {
          setIsFetchingFacilities(true);
          const response = await getFacilitiesDetails({ clubId: currentClub?.id, isPast: false });
          dispatch(setFacilitiesDetails(response));
          setIsFetchingFacilities(false);
      }

      useEffect(() => {
          !isFetchingStaffs && currentClub && currentClub?.id && (staffDetails == undefined || staffDetails?.length == 0) &&
          fetchStaffList();
          !isFetchingFacilities && currentClub && currentClub?.id && (facilitiesDetails == undefined || facilitiesDetails?.length == 0) &&
          fetchFacilityList();
      }, [data]);

      const fetchStaffSupervisor = (staffId:any) => {
        const staff = staffDetails?.find((item:any) => item?.id == staffId);
        return staff ? staff?.kanjiName : '-';
      }

      const fetchPracticeGrounds = (groundIds:any) => {
        const grounds = facilitiesDetails?.filter((item:any) => groundIds?.includes(item?.id));
        return grounds && grounds.length > 0 ? grounds.map((item:any) => item?.facilityName).join(', ') : '-';
      }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto', mt: addData ? 8 : 0 }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-row-${i}`}
                        onClick={() => {dispatch(setSelectedTeam(d))}}
                        >
                            <TableCell className='fs12'>
                                {d.teamDetails.teamName}
                            </TableCell>
                            <TableCell className='fs12'>
                                {d.teamDetails.established}
                            </TableCell>
                            <TableCell className='fs12'>
                                {d.teamDetails.ageGroup}
                            </TableCell>
                            <TableCell className='fs12'>
                                {d.teamDetails?.staffSupervisor ? fetchStaffSupervisor(d.teamDetails?.staffSupervisor) : '-'}
                            </TableCell>
                            <TableCell className='fs12'>
                                {d.teamDetails?.practiceGrounds ? fetchPracticeGrounds(d.teamDetails?.practiceGrounds) : '-'}
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={(e:any) => {e.stopPropagation(); !isAdmin && manageDeleteRow(d);}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default TeamsTable;